import { NetworkMotif } from "@/components/governance/NetworkMotif";

// One governance pillar. Copy is data-driven so verified profiles can be added
// later without redesigning the page. Hover: subtle lift + motif drift (reduced-motion safe).
export function GovernancePillarCard({ id, title, body, tags }) {
  return (
    <article
      data-testid={`governance-card-${id}`}
      className="group relative flex flex-col overflow-hidden rounded-2xl border border-[var(--line)] bg-[var(--paper)] p-8 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[var(--cobalt)] hover:shadow-[0_18px_40px_-20px_rgba(16,37,63,0.28)] motion-reduce:transition-none motion-reduce:hover:translate-y-0"
    >
      <NetworkMotif className="pointer-events-none absolute -right-6 -top-6 h-36 w-36 text-[var(--cobalt)] opacity-[0.07] transition-transform duration-500 group-hover:translate-x-1.5 group-hover:-translate-y-1.5 motion-reduce:transition-none motion-reduce:group-hover:transform-none" />
      <h3 className="relative font-display text-xl font-bold text-navy">{title}</h3>
      <div className="relative mt-4 flex-1 space-y-3">
        {body.map((p, i) => (
          <p key={i} className="text-sm text-[var(--mineral)]" style={{ lineHeight: 1.75 }}>{p}</p>
        ))}
      </div>
      <p className="relative mt-6 flex flex-wrap gap-x-2 gap-y-1 border-t border-[var(--line)] pt-4 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-[var(--mineral)]">
        {tags.map((t, i) => (
          <span key={t}>
            {t}
            {i < tags.length - 1 && <span className="mx-1.5 text-[var(--cobalt)]">·</span>}
          </span>
        ))}
      </p>
    </article>
  );
}
